<div class="marginBottomQuarterEm" *ngIf="isLoggedIn && (screenType !== 'phone')">
    <ng-container  *ngFor="let sr of currentSelections; let idx = index;" >
        <span class="link smallish" title="click to un-select" (click)="unselect(sr)" *ngIf="sr.resource">
            <span class="fas fa-times-circle"></span>&nbsp;<span class="fas fa-{{ getPageIcon(sr.ehName) }}"></span> ({{ sr.resource.keyField.displayValue}})
            <span *ngIf="idx+1 < currentSelections.length"> / </span>
        </span>
    </ng-container>
</div>
